// Closes the notifications this device has already delivered whose link starts
// with one of `urlPrefixes` (e.g. ["/events", "/upcoming"]). Used when something is marked as seen
// (here or on another device) so a stale "event changed" notification doesn't
// linger in the notification shade. Best effort: quietly does nothing where the
// browser can't list notifications.
export const closeDeliveredNotifications = (urlPrefixes) => {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker
    .getRegistration()
    .then((registration) =>
      registration && registration.getNotifications
        ? registration.getNotifications()
        : []
    )
    .then((notifications) =>
      notifications
        .filter(
          (n) =>
            n.data &&
            typeof n.data.url === "string" &&
            urlPrefixes.some((prefix) => n.data.url.startsWith(prefix))
        )
        .forEach((n) => n.close())
    )
    .catch(() => {});
};
